import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import deliveryModesService from '../../services/delivery-modes';
import profilesService from '../../services/profiles';

import FormControl from '@mui/material/FormControl';
import SelectProfiles from './SelectProfiles';
import SelectGroups from './SelectGroups';
import FormField from './FormField';
import ToggleRadio from './ToggleRadio';

class SetDeliveryModeVisibility extends React.Component {

  render () {
    const { data, onChange, onError, id_profile } = this.props;

    return (
      <>
        <FormField>
          <FormControl>
            <ToggleRadio
              name="visibility"
              id="visibility"
              value={data?.visibility || ''}
              onChange={ (e) => onChange({...data, ...{...{visibility: e.target.value}}}) }
              options={[
                {
                  value: deliveryModesService.VISIBILITY_PUBLIC,
                  label: {
                    title: "Publique",
                    infos: "Mode de livraison disponible pour tous vos abonnés" + (data.context === deliveryModesService.CONTEXT_BTOC ? " particuliers." : " professionnels."),
                  }
                },
                {
                  value: deliveryModesService.VISIBILITY_SCOPED,
                  label: {
                    title: "Sélective",
                    infos: "Mode de livraison disponible uniquement pour une sélection parmi vos abonnés" + (data.context === deliveryModesService.CONTEXT_BTOC ? " particuliers." : " professionnels."),
                  }
                }
              ]}
            />
          </FormControl>
        </FormField>

        { data.visibility === deliveryModesService.VISIBILITY_SCOPED && (
          <>
            <FormField>
              <SelectProfiles
                title="Abonnés"
                label="Ajouter un abonné"
                value={data?.scopes?.profiles || []}
                onChange={ (profiles) => onChange({...data, ...{scopes: {...data.scopes, ...{profiles}}}}) }
                onError={onError}
                query={ {id_profile_subscribed_to: id_profile, type: (data.context === deliveryModesService.CONTEXT_BTOC ? profilesService.TYPE_PART : profilesService.TYPE_PRO)} }
              />
            </FormField>

            <FormField>
              <SelectGroups
                title="Groupes"
                label="Ajouter un groupe"
                value={data?.scopes?.groups || []}
                onChange={ (groups) => onChange({...data, ...{scopes: {...data.scopes, ...{groups}}}}) }
                onError={onError}
                query={ {id_profile: id_profile} }
                canCreate={true}
              />
            </FormField>
          </>
        ) }
      </>
    )
  }
}

const styles = theme => ({
  form_control: {
    width: '100%',
  },
  input: {
    width: '100%',
  },
  radioFormControl: {
    alignItems: 'flex-start',
    marginBottom: theme.spacing(2),
  },
  radioFormControlLabel: {
    marginTop: theme.spacing(1),
    cursor: 'pointer',
  },
});

SetDeliveryModeVisibility.propTypes = {
  id_profile: PropTypes.PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  data: PropTypes.object,
};

SetDeliveryModeVisibility.defaultProps = {
  data: {}
};

export default withStyles(styles, { withTheme: true })(SetDeliveryModeVisibility);
